import random from 'lodash/random'

const POOL_LIST = []
class Pool {
  // 获取随机数key
  _getRandomKey = () => {
    return random(0, 100000, false)
  }

  // 获取是否开始中
  _isStart = k => {
    return POOL_LIST.indexOf(k) !== -1
  }

  // 开始
  start = (cb, time) => {
    const that = this
    const k = this._getRandomKey()
    POOL_LIST.push(k)
    const start = t => {
      setTimeout(
        async () => {
          if (that._isStart(k)) {
            try {
              await cb(that.stop.bind(that, k))
            } finally {
              if (that._isStart(k)) {
                start()
              }
            }
          }
        },
        typeof t === 'number' ? t : time
      )
    }
    start(3000)
  }

  // 停止某一轮询
  stop = k => {
    const index = POOL_LIST.indexOf(k)
    if (index !== -1) {
      POOL_LIST.splice(index, 1)
    }
  }
}

const createPool = () => {
  return new Pool()
}
export default createPool
